import { selectLoginFormData } from "./../Auth/AuthSelectors";
import { Direction, Languages } from "../../../Models";
import { Api, LogService } from "../../../Services";
import store, { AppThunk } from "../../Store";
import AuthState from "../Auth";
import { Actions } from "./GeneralSlice";
import { selectIsUserLoggedIn, selectUserWantsToBeRemembered } from "./GeneralSelectors";
import { GeneralState, AgriSolutionState, SolutionState } from "../..";
import { shareableItemTypes } from "../../../Utils/Enums";

export const setLanguage =
  (language: Languages | string): AppThunk =>
  async (dispatch: any) => {
    try {
      console.log("setLanguage", language);
      const response = await Api.Users.updateLanguage(language);
      if (response && response.statusCode === 200 && response.data) {
        //  const direction = language === 'he' ? Direction.RTL : Direction.LTR;
        const direction = Direction.LTR;
        await dispatch(Actions.setDirection(direction));
        await dispatch(Actions.setLanguage(language));
      }
    } catch (ex) {
      LogService.logError(`Exception occurred in setLanguage: ${ex}`);
    }
  };
export const initApp = (): AppThunk => async (dispatch: any, getState: any) => {
  try {
    await dispatch(Actions.setAppIsReady(false));
    const state = getState();
    const userIsLoggedIn = selectIsUserLoggedIn(state);
    const userWantsToBeRemembered = selectUserWantsToBeRemembered(state);
    const userLoginData = selectLoginFormData(state);
    dispatch(
      GeneralState.Actions.setGreenBar({
        isShow: false,
        lastIsShow: false,
      }),
    );
    dispatch(AgriSolutionState.Actions.setItemId(null));
    dispatch(SolutionState.Actions.setItemId(null));
    dispatch(AgriSolutionState.Actions.reset());
    dispatch(SolutionState.Actions.reset());
    dispatch(GeneralState.Actions.setSummaryDescription(""));
    console.log("----------------------------------------");
    console.log("userIsLoggedIn", userIsLoggedIn);
    console.log("userWantsToBeRemembered", userWantsToBeRemembered);
    console.log("userLoginData", userLoginData);
    console.log("----------------------------------------");
    const params = new URLSearchParams(location.search);
    const saveItemId = params.get("saveItemId");
    const typeOfSharing = params.get("type");
    console.log("login saveItemId", saveItemId);
    console.log("login typeOfSharing", typeOfSharing);

    if (saveItemId) {
      dispatch(GeneralState.Actions.setUserNeedToViewSharableItem(true));
      dispatch(GeneralState.Actions.setTypeOfSharableItem(Number(typeOfSharing)));
      dispatch(GeneralState.Actions.setSharedSavedItemId(Number(saveItemId)));
    } else {
      dispatch(GeneralState.Actions.setTypeOfSharableItem(shareableItemTypes.empty));
    }
    /* Log the user off if he does not wish to stay logged in */
    if (!userIsLoggedIn) {
      dispatch(Actions.logOut(userWantsToBeRemembered));
    }
    /* Select state in case it has changed after the logout */
    // if (userWantsToBeRemembered) {
    //   dispatch(
    //     AuthState.Thunks.login(
    //       userLoginData.email,
    //       userLoginData.password,
    //       userLoginData.keepMeLoggedIn,
    //     ),
    //   );
    // }

    if (!userWantsToBeRemembered) {
      dispatch(Actions.logOut(userWantsToBeRemembered));
    }
    await dispatch(AuthState.Thunks.initRegistrationData());
    if (userIsLoggedIn) {
      await dispatch(initMainAppData());
      //await dispatch(getAllSavedItems());
    }
    await dispatch(Actions.setAppIsReady(true));
  } catch (ex) {
    LogService.logError(`Exception occurred in init app: ${ex}`);
  }
};
export const initMainAppData = (): AppThunk => async (dispatch: any, getState: any) => {
  try {
    const response = await Api.Utils.homePageData();
    if (response && response.statusCode === 200 && response.data) {
      await dispatch(Actions.setMainPageData(response.data));
    } else if (response.statusCode === 401 || (response as any).StatusCode === 401) {
      const state = getState();
      const userWantsToBeRemembered = selectUserWantsToBeRemembered(state);
      dispatch(Actions.logOut(userWantsToBeRemembered));
    }
  } catch (ex) {
    LogService.logError(`Exception occurred in initMainAppData: ${ex}`);
  }
};
export const logout = (): AppThunk => async (dispatch: any) => {
  try {
    const response = await Api.Auth.logout();
    if (response && response.statusCode === 200 && response.data) {
      store.dispatch({ type: "USER_LOGOUT" });
      await dispatch(initApp());
    }
  } catch (ex) {
    LogService.logError(`Exception occurred in logout: ${ex}`);
  }
};
